import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import '../../stylesheet/tabdesign.css';
import AuthNavbar from '../navigation/authnavigation.jsx';

import MobilePhoneGoogle from '../../images/MobilePhoneGoogle.png';
import DigitalCardMockupGoogleFull from '../../images/DigitalCardMockupGoogleFull.png';
import MobilePhoneGoogleNZ from '../../images/MobilePhoneGoogle-nz.png';
import DigitalCardMockupGoogleFullNZ from '../../images/DigitalCardMockupGoogleFull-nz.png';
import googlepaylogo from '../../images/google-pay-logo.png';
import klickexlogo from '../../images/KlickExLogo_w.png';
import GoogleWallet1 from '../../images/GoogleWallet1.png';



const mapStateToProps = state =>
    ({

    })
const mapDispatchToProps = dispatch =>
    ({

    })

class GoogleWallet extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    // handleChange(e) {
    //     this.setState({
    //         selectedOption: e.target.value
    //     })
    // }
    componentWillMount() {

    }
    componentDidMount() {

    }

    render() {      
       
        var cardTypes = localStorage.getItem('cardTypes')
      
        return (
            <div  className="row">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                pauseOnHover
            />
                <div className="col-md-12 m-0 p-0">
                    <AuthNavbar />
                </div>

                <div className="col-12 bggrey pt-5" style={{ marginTop: "-22px" }}>
                    <div className="container " style={{}}>
                        <div className="row googlewallet bggrey">
                            <div className="col-lg-7 my-auto">
                                <div className="header-content ml-2">
                                    <h2 className="text-center text-sm-left">
                                       Make Contactless payments with Google Pay<sup>TM</sup> <br />
                                       Add your KlickEx Money Card to Google Wallet<sup>TM</sup>
                                    </h2>
                                    <p className="mb-5">Welcome to easy, fast and secure payments</p>
                                    <img src={klickexlogo} className="img-fluid" alt="" style={{ height: "40px" , paddingRight : "10px" , borderRight : "1px solid black" }} />
                                    <img src={googlepaylogo} className="img-fluid mt-2 ml-2" alt="" style={{ height: "60px" }} />
                                </div>
                            </div>
                            <div className="col-lg-5 my-auto">
                                <div className="device-container">
                                    <div className="device-mockup iphone6_plus portrait white">
                                        <div className="device">
                                            <div className="screen">
                                                {localStorage.getItem('pform') === 'AU' ?
                                                    <img src={MobilePhoneGoogle} className="img-fluid" alt="" />
                                                    :
                                                    <img src={MobilePhoneGoogleNZ} className="img-fluid" alt="" />
                                                }
                                                
                                            </div>
                                            <div className="button">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                
                                <div className="col-12">
                                    <div className="container " >
                
                                        <div className="row pt-4 pb-5">
                                            <div className="col-md-6 col-sm-12 text-center pt-4 pb-4">
                                                {localStorage.getItem('pform') === 'AU' ?
                                                    <img src={DigitalCardMockupGoogleFull} className=" NewAppleWalletFullPhone img-fluid mt-4" alt=""  />
                                                :
                                                    <img src={DigitalCardMockupGoogleFullNZ} className=" NewAppleWalletFullPhone img-fluid mt-4" alt=""  />
                                                }                                                
                                            </div>
                                            <div className="col-md-6 col-sm-12 header-content featured-right">
                                                <h2 className="mt-5 pb-2 text-left" >Add your card to Google Wallet. <br/> Setup is easy.</h2>

                                                <img src={GoogleWallet1} className="mb-2" style={{height: '34px'}}/> <br/>
                                                <p className="mt-2 text-left">
                                                    Adding your card to Google Wallet is simple. Here's how to get started.
                                                </p>
                                                
                                                <h5 className="mt-2 ml-2 text-left" ><strong>To add your KlickEx Money Card to your Google wallet:</strong></h5>
                                                <ol className='text-left ml-4'>
                                                    <li>Open the Google Wallet app.</li>
                                                    <li>At the bottom, tap Add to Wallet.</li>
                                                    <li>Tap Payment card.</li>
                                                    <li>Tap New credit or debit card.</li>
                                                    <li>Click on enter card details manually at the bottom.</li>
                                                    <li>Fill out card details and click save and continue.</li>
                                                    <li>Accept the terms and conditions, and your card has been added to your mobile wallet.</li>
                                                    <li>You will now be able to make contactless payments anywhere Google Pay is accepted.</li>
                                                </ol>
                
                                                <h5 className="mt-1 ml-2 text-left" ><strong>Support Links</strong></h5>
                                                <p className="mb-1 ml-2 text-left"><a href="https://pay.google.com/intl/en_au/about/learn/" target="_blank" > https://pay.google.com/intl/en_au/about/learn/</a></p>
                
                                            </div>
                
                                        </div>
                                    </div>
                                </div>
                                
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GoogleWallet);


// WEBPACK FOOTER //
// ./src/components/wallet/googlewallet.jsx